import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private dataSubject = new Subject<string>();

  constructor() {}

  sendDataToParent(data: string) {
    this.dataSubject.next(data);
  }

  getDataSubject() {
    return this.dataSubject.asObservable();
  }
}
